import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "../utility/http.client";

@Injectable()
export class CRMService {
  constructor(private http: HttpClient) {}

  addCRMobj(data: any): Observable<any> {
    return this.http.post("/crm/addCRMObj", data);
  }

  addRateObj(data: any): Observable<any> {
    return this.http.post("/crm/addRateObj", data);
  }

  getCRMObjs(data: any): Observable<any> {
    return this.http.get("/crm/getCRMObjs", data);
  }
  getRateObjs(data: any): Observable<any> {
    return this.http.get("/crm/getRateObjs", data);
  }

  removeCRMObj(data: any): Observable<any> {
    return this.http.post("/crm/removeCRMObj", data);
  }
 uploadClientFiles(data: any): Observable<any> {
    return this.http.post("/crm/uploadClientFiles", data);
  }
  removeRateObj(data: any): Observable<any> {
    return this.http.post("/crm/removeRateObj", data);
  }

  getCRMObjDetails(data: any): Observable<any> {
    return this.http.get("/crm/getCRMObjDetails/", data);
  }

  getCRMObjDetailsByIds(data: any): Observable<any> {
    return this.http.get("/crm/getCRMObjDetailsByIds/", data);
  }

  getRateObjDetails(data: any): Observable<any> {
    return this.http.get("/crm/getRateObjDetails/", data);
  }

  updateCRMObj(data: any): Observable<any> {
    ////console.log("data ",data)
    return this.http.post("/crm/updateCRMObj/", data);
  }
  saveNotes(data: any): Observable<any> {
    ////console.log("data ",data)
    return this.http.post("/crm/saveNotes/", data);
  }
  updateRateObj(data: any): Observable<any> {
    ////console.log("data ",data)
    return this.http.post("/crm/updateRateObj/", data);
  }
  changeFileName(data: any): Observable<any>{
       return this.http.post('/crm/changeFileName', data)
  }
  checkEmail(data: any): Observable<any> {
    //console.log("checking email ");
    return this.http.post("/crm/checkEmail/", data);
  }
  removeCrmFile(data: any): Observable<any> {
    return this.http.post("/crm/removeCrmFile", data);
  }
  sendCrmMail(data: any): Observable<any> {
    console.log("data in service------", data)
    return this.http.post("/crm/sendCrmMail", data);
  }
  downloadCRMOrderFiles(data: any): Observable<any> {
    return this.http.getFile(
      "/crm/downloadCRMOrderFiles",
      data
    );
  }
}
